/** Order status helpers — colors, labels, transitions. */

export type OrderStatus =
  | "created"
  | "paid"
  | "confirmed"
  | "packing"
  | "shipped"
  | "delivering"
  | "delivered"
  | "cancelled"
  | "returned";

export const STATUS_LABELS: Record<OrderStatus, string> = {
  created: "Создан",
  paid: "Оплачен",
  confirmed: "Подтверждён",
  packing: "Собирается",
  shipped: "Отправлен",
  delivering: "В доставке",
  delivered: "Доставлен",
  cancelled: "Отменён",
  returned: "Возвращён",
};

export const STATUS_VARIANTS: Record<
  OrderStatus,
  "default" | "secondary" | "destructive" | "outline" | "success" | "warning"
> = {
  created: "warning",
  paid: "default",
  confirmed: "default",
  packing: "default",
  shipped: "default",
  delivering: "default",
  delivered: "success",
  cancelled: "destructive",
  returned: "destructive",
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  pending: "Ожидает оплаты",
  paid: "Оплачен",
  refunded: "Возвращён",
  failed: "Неудачно",
  cash_on_delivery: "Наличными при получении",
};

export const STATUS_FLOW: OrderStatus[] = [
  "created",
  "paid",
  "confirmed",
  "packing",
  "shipped",
  "delivering",
  "delivered",
];
